import * as React from 'react';
import { PageProps } from 'gatsby';
import classNames from 'classnames';
import { BenefitItemProps } from '../../types';
import { useStyles } from '@/hooks/useStyles';

const benefitInfoClasses = classNames(
  'bg-primary text-white px-[1.88rem] py-[1.25rem] rounded-2xl min-h-[4.062rem]'
);
const benefitTitleClasses = classNames('');
const benefitDescriptionClasses = classNames(
  'lg:max-h-0 lg:overflow-hidden lg:opacity-0',
  'lg:group-hover/benefit:max-h-[15rem] lg:group-hover/benefit:opacity-100'
);

const benefitContainerClasses = classNames(
  'group/benefit relative  text-center mt-[calc(7.875rem)] lg:mt-0'
);

const BenefitItem: React.FC<PageProps<BenefitItemProps>> = ({ data }) => {
  const { joinClasses } = useStyles();

  const desktopClasses = {
    infoContainer: 'lg:block lg:h-[unset]',
    title: benefitTitleClasses,
    description: benefitDescriptionClasses
  };
  const mobileClasses = {
    infoContainer: classNames(
      benefitInfoClasses,
      'flex flex-col items-stretch h-full'
    ),
    title: classNames('text-base font-bold transition-all duration-300'),
    description: classNames('transition-all ease-in duration-300')
  };

  return (
    <div className={benefitContainerClasses}>
      <img
        data-test-id="benefit-item-icon"
        src={data.icon}
        alt={data.title}
        className="absolute left-[50%] translate-y-[calc(-100%-0.31rem)] translate-x-[-50%] w-[6.875rem] h-[6.875rem]"
      />
      <div
        className={joinClasses([
          desktopClasses.infoContainer,
          mobileClasses.infoContainer
        ])}
      >
        <p
          data-test-id="benefit-item-title"
          className={joinClasses([desktopClasses.title, mobileClasses.title])}
        >
          {data.title}
        </p>
        <p
          data-test-id="benefit-item-description"
          className={joinClasses([
            desktopClasses.description,
            mobileClasses.description
          ])}
        >
          {data.description}
        </p>
      </div>
    </div>
  );
};

export default BenefitItem;
